/**
 * ESPN College Logo Mappings - Auto-generated
 * Generated: 2025-10-06T15:33:06.011Z
 *
 * DO NOT EDIT MANUALLY
 * To regenerate: npm run update-logo-mapping
 *
 * Coverage: 303/306 teams (99%)
 */

// Comprehensive static mapping for college team logos
// Using ESPN CDN URLs with verified team IDs
let WIKIMEDIA_LOGO_MAP: Record<string, string> = {
  'AAMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2010.png',
  'ACU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2000.png',
  'AF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2005.png',
  'AKRON': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2006.png',
  'ALAST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2011.png',
  'ALB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2015.png',
  'ALCORN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2016.png',
  'APP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2026.png',
  'APSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2046.png',
  'ARIZ': 'https://a.espncdn.com/i/teamlogos/ncaa/500/12.png',
  'ARK': 'https://a.espncdn.com/i/teamlogos/ncaa/500/8.png',
  'ARMY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/349.png',
  'ARST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2032.png',
  'ASU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/9.png',
  'AUB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2.png',
  'BAMA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/333.png',
  'BAY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/239.png',
  'BC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/103.png',
  'BCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2065.png',
  'BELM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2057.png',
  'BGSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/189.png',
  'BING': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2066.png',
  'BRAD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/71.png',
  'BROWN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/225.png',
  'BSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2050.png',
  'BU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/91.png',
  'BUT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2086.png',
  'BYU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/252.png',
  'CAL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/25.png',
  'CAM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2097.png',
  'CBU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2856.png',
  'CCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/324.png',
  'CHA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/411.png',
  'CHAR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2429.png',
  'CIN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2132.png',
  'CIT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2643.png',
  'CLEM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/228.png',
  'CMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2117.png',
  'COL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2442.png',
  'COLG': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2142.png',
  'COLO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/38.png',
  'CONN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/41.png',
  'COP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2154.png',
  'CORN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/172.png',
  'CP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/13.png',
  'CREI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/156.png',
  'CSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/325.png',
  'CSUB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2934.png',
  'CSUF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2239.png',
  'CSULB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/299.png',
  'CSUN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2463.png',
  'DART': 'https://a.espncdn.com/i/teamlogos/ncaa/500/159.png',
  'DAV': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2166.png',
  'DAY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2168.png',
  'DEL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/48.png',
  'DEPAUL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/305.png',
  'DRAKE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2181.png',
  'DREX': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2182.png',
  'DSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2169.png',
  'DU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2172.png',
  'DUKE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/150.png',
  'DUQ': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2184.png',
  'ECU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/151.png',
  'EIU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2197.png',
  'EKU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2198.png',
  'ELON': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2210.png',
  'EMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2199.png',
  'ETAMU': '/logos/college/etamu.png',
  'EVAN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/339.png',
  'EWU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/331.png',
  'FAMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/50.png',
  'FAU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2226.png',
  'FDU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/161.png',
  'FGCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/526.png',
  'FIU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2229.png',
  'FORD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2230.png',
  'FRES': 'https://a.espncdn.com/i/teamlogos/ncaa/500/278.png',
  'FSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/52.png',
  'FUR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/231.png',
  'GCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2253.png',
  'GMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2244.png',
  'GONZ': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2250.png',
  'GRAM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2755.png',
  'GS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/290.png',
  'GSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2247.png',
  'GT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/59.png',
  'GTOWN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/46.png',
  'GW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/45.png',
  'HAMP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2261.png',
  'HART': '/logos/college/hart.png',
  'HARV': 'https://a.espncdn.com/i/teamlogos/ncaa/500/108.png',
  'HAW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/62.png',
  'HCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2277.png',
  'HOF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2275.png',
  'HOW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/47.png',
  'HPU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2272.png',
  'ILL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/356.png',
  'ILS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2287.png',
  'INST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/282.png',
  'IONA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/314.png',
  'IOWA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2294.png',
  'ISU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/304.png',
  'IU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/84.png',
  'IUI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/85.png',
  'JMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/256.png',
  'JSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2296.png',
  'JU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/294.png',
  'JXST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/55.png',
  'KENN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/338.png',
  'KENT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2309.png',
  'KSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2306.png',
  'KU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2305.png',
  'LAM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2320.png',
  'LAS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2325.png',
  'LEH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2329.png',
  'LIB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2335.png',
  'LMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2351.png',
  'LOU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/97.png',
  'LSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/99.png',
  'LT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2348.png',
  'LU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2815.png',
  'LUC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2350.png',
  'MAINE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/311.png',
  'MAN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2363.png',
  'MARQ': 'https://a.espncdn.com/i/teamlogos/ncaa/500/269.png',
  'MARS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/276.png',
  'MCNS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2377.png',
  'MEM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/235.png',
  'MIA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2390.png',
  'MICH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/130.png',
  'MINN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/135.png',
  'MISS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/145.png',
  'MIZ': 'https://a.espncdn.com/i/teamlogos/ncaa/500/142.png',
  'MIZST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2623.png',
  'MON': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2405.png',
  'MORE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2413.png',
  'MORG': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2415.png',
  'MSST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/344.png',
  'MSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/127.png',
  'MTST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/147.png',
  'MTSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2393.png',
  'MURR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/93.png',
  'MVSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2400.png',
  'NAU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2464.png',
  'NAVY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2426.png',
  'NCAT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2448.png',
  'NCSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/152.png',
  'ND': 'https://a.espncdn.com/i/teamlogos/ncaa/500/87.png',
  'NDSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2449.png',
  'NEB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/158.png',
  'NEU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/111.png',
  'NEV': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2440.png',
  'NICH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2447.png',
  'NIU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2459.png',
  'NKU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/94.png',
  'NMSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/166.png',
  'NOVA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/222.png',
  'NSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2450.png',
  'NW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/77.png',
  'OAK': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2473.png',
  'ODU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/295.png',
  'OHIO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/195.png',
  'OKST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/197.png',
  'ORE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2483.png',
  'ORST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/204.png',
  'ORU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/198.png',
  'OSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/194.png',
  'OU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/201.png',
  'PAC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/279.png',
  'PC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2507.png',
  'PENN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/219.png',
  'PEPP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2492.png',
  'PFW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2870.png',
  'PITT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/221.png',
  'PORTST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2502.png',
  'PRIN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/163.png',
  'PSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/213.png',
  'PUR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2509.png',
  'PVAMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2504.png',
  'QU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2511.png',
  'RICE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/242.png',
  'RICH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/257.png',
  'RMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2523.png',
  'RUT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/164.png',
  'SAC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/16.png',
  'SBU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/179.png',
  'SC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2579.png',
  'SCSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2569.png',
  'SCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2541.png',
  'SDSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/21.png',
  'SELU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2545.png',
  'SEMO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2546.png',
  'SFA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2617.png',
  'SFU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2598.png',
  'SHSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2534.png',
  'SHU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2529.png',
  'SIEN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2561.png',
  'SIU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/79.png',
  'SIUE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2565.png',
  'SJSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/23.png',
  'SJU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2599.png',
  'SLU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/139.png',
  'SMC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2608.png',
  'SMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2567.png',
  'STAN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/24.png',
  'STET': 'https://a.espncdn.com/i/teamlogos/ncaa/500/56.png',
  'SU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2582.png',
  'SUU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/253.png',
  'SYR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/183.png',
  'TAMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/245.png',
  'TAMUC': '/logos/college/tamuc.png',
  'TAMUCC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/357.png',
  'TARLETON': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2627.png',
  'TCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2628.png',
  'TEM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/218.png',
  'TENN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2633.png',
  'TEX': 'https://a.espncdn.com/i/teamlogos/ncaa/500/251.png',
  'TOL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2649.png',
  'TOW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/119.png',
  'TROY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2653.png',
  'TSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2634.png',
  'TTU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2641.png',
  'TUL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2655.png',
  'TULSA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/202.png',
  'TXSO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2640.png',
  'TXST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/326.png',
  'UAB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/5.png',
  'UAPB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2029.png',
  'UB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2084.png',
  'UCA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2110.png',
  'UCD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/302.png',
  'UCF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2116.png',
  'UCI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/300.png',
  'UCLA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/26.png',
  'UCR': 'https://a.espncdn.com/i/teamlogos/ncaa/500/27.png',
  'UCSB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2540.png',
  'UCSD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/28.png',
  'UDM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2174.png',
  'UF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/57.png',
  'UGA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/61.png',
  'UH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/248.png',
  'UI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/70.png',
  'UIC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/82.png',
  'UIW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2916.png',
  'UK': 'https://a.espncdn.com/i/teamlogos/ncaa/500/96.png',
  'ULL': 'https://a.espncdn.com/i/teamlogos/ncaa/500/309.png',
  'ULM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2433.png',
  'UM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/149.png',
  'UMASS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/113.png',
  'UMBC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2378.png',
  'UMD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/134.png',
  'UMES': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2379.png',
  'UMKC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/140.png',
  'UMLW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2349.png',
  'UNA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2453.png',
  'UNC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/153.png',
  'UNCW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/350.png',
  'UND': 'https://a.espncdn.com/i/teamlogos/ncaa/500/155.png',
  'UNF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2454.png',
  'UNH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/160.png',
  'UNI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2460.png',
  'UNLV': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2439.png',
  'UNM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/167.png',
  'UNO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2443.png',
  'UNT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/249.png',
  'UP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2501.png',
  'URI': 'https://a.espncdn.com/i/teamlogos/ncaa/500/227.png',
  'USA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/6.png',
  'USC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/30.png',
  'USD': 'https://a.espncdn.com/i/teamlogos/ncaa/500/301.png',
  'USF': 'https://a.espncdn.com/i/teamlogos/ncaa/500/58.png',
  'USM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2572.png',
  'UST': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2900.png',
  'USU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/328.png',
  'UTAH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/254.png',
  'UTC': 'https://a.espncdn.com/i/teamlogos/ncaa/500/236.png',
  'UTEP': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2638.png',
  'UTM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2630.png',
  'UTSA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2636.png',
  'UTU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/3101.png',
  'UVA': 'https://a.espncdn.com/i/teamlogos/ncaa/500/258.png',
  'UVM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/261.png',
  'UVU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/3084.png',
  'UW': 'https://a.espncdn.com/i/teamlogos/ncaa/500/264.png',
  'UWGB': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2739.png',
  'UWM': 'https://a.espncdn.com/i/teamlogos/ncaa/500/270.png',
  'VALPO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2674.png',
  'VANDY': 'https://a.espncdn.com/i/teamlogos/ncaa/500/238.png',
  'VCU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2670.png',
  'VT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/259.png',
  'W&M': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2729.png',
  'WAKE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/154.png',
  'WEBER': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2692.png',
  'WICH': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2724.png',
  'WIN': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2737.png',
  'WIS': 'https://a.espncdn.com/i/teamlogos/ncaa/500/275.png',
  'WIU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2710.png',
  'WKU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/98.png',
  'WMU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2711.png',
  'WRIGHT': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2750.png',
  'WSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/265.png',
  'WVU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/277.png',
  'WYO': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2751.png',
  'XU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2752.png',
  'YALE': 'https://a.espncdn.com/i/teamlogos/ncaa/500/43.png',
  'YSU': 'https://a.espncdn.com/i/teamlogos/ncaa/500/2754.png',
};

// Server mapping disabled for now - using comprehensive local mapping
let mappingLoaded = true; // Mark as loaded so sync function works

async function loadServerMapping(): Promise<void> {
  console.log('Using comprehensive ESPN college logo mappings');
}

// Alternative name mappings for teams that might have different naming conventions
const ALTERNATIVE_MAPPINGS: Record<string, string> = {
  'ALABAMASTATE': 'ALAST',
  'ARIZONASTATE': 'ASU'
};

/**
 * Get college logo URL for a team
 * Enhanced with comprehensive ESPN mappings
 */
export async function getWikimediaCollegeLogo(abbreviation: string, teamName?: string): Promise<string | null> {
  if (!abbreviation) return null;

  // Ensure static mapping is loaded
  await loadServerMapping();

  const abbrev = abbreviation.toUpperCase();

  // Special case for GCU - keep local PNG
  if (abbrev === 'GCU') {
    return WIKIMEDIA_LOGO_MAP['GCU'] || `/logos/college/gcu.png`;
  }

  // Handle ASU conflict - differentiate between Arizona State and Alabama State
  if (abbrev === 'ASU') {
    if (teamName && teamName.toLowerCase().includes('alabama')) {
      return WIKIMEDIA_LOGO_MAP['ALAST'] || null;
    }
    // Default ASU to Arizona State
    return WIKIMEDIA_LOGO_MAP['ASU'] || null;
  }

  // Try direct mapping first
  let logoUrl = WIKIMEDIA_LOGO_MAP[abbrev];

  // Try alternative mappings if direct lookup fails
  if (!logoUrl) {
    const altKey = Object.keys(ALTERNATIVE_MAPPINGS).find(key =>
      abbreviation.toUpperCase().includes(key)
    );
    if (altKey) {
      logoUrl = WIKIMEDIA_LOGO_MAP[ALTERNATIVE_MAPPINGS[altKey]];
    }
  }

  // Debug logging in development
  if (process.env.NODE_ENV === 'development' && logoUrl) {
    console.log(`🔍 Logo found for ${abbrev}: ${logoUrl}`);
  } else if (process.env.NODE_ENV === 'development') {
    console.warn(`❌ No logo found for ${abbrev} (${teamName})`);
  }

  return logoUrl || null;
}

/**
 * Synchronous version for performance - returns cached URLs immediately
 */
export function getWikimediaCollegeLogoUrlsSync(abbreviation: string, teamName?: string): string[] {
  if (!abbreviation) return [];

  const abbrev = abbreviation.toUpperCase();
  const urls: string[] = [];

  // Special case for GCU
  if (abbrev === 'GCU') {
    const url = WIKIMEDIA_LOGO_MAP['GCU'] || '/logos/college/gcu.png';
    urls.push(url);
    return urls;
  }

  // Handle ASU conflict
  if (abbrev === 'ASU') {
    if (teamName && teamName.toLowerCase().includes('alabama')) {
      const url = WIKIMEDIA_LOGO_MAP['ALAST'];
      if (url) urls.push(url);
    } else {
      const url = WIKIMEDIA_LOGO_MAP['ASU'];
      if (url) urls.push(url);
    }
    return urls;
  }

  // Try direct mapping
  const staticUrl = WIKIMEDIA_LOGO_MAP[abbrev];
  if (staticUrl) {
    urls.push(staticUrl);
  }

  // Try alternative mappings
  const altKey = Object.keys(ALTERNATIVE_MAPPINGS).find(key =>
    abbreviation.toUpperCase().includes(key)
  );
  if (altKey) {
    const altUrl = WIKIMEDIA_LOGO_MAP[ALTERNATIVE_MAPPINGS[altKey]];
    if (altUrl && !urls.includes(altUrl)) {
      urls.push(altUrl);
    }
  }

  // Debug logging for development
  if (process.env.NODE_ENV === 'development') {
    console.log(`🔍 Logo lookup for ${abbreviation} (${teamName}):`);
    console.log(`   - Static mapping: ${staticUrl ? 'Found' : 'Not found'}`);
    console.log(`   - URLs returned: ${urls.length}`);
    if (urls.length > 0) {
      console.log(`   - First URL: ${urls[0]}`);
    }
  }

  return urls;
}

/**
 * Async version that tries to get enhanced logo URLs
 */
export async function getWikimediaCollegeLogoAsync(abbreviation: string, teamName?: string): Promise<string | null> {
  return await getWikimediaCollegeLogo(abbreviation, teamName);
}

/**
 * Get multiple logo URLs for fallback handling
 */
export function getCollegeLogoUrls(abbreviation: string, teamName?: string): string[] {
  return getWikimediaCollegeLogoUrlsSync(abbreviation, teamName);
}
